import { render, staticRenderFns } from "./Parcerias.vue?vue&type=template&id=49b5d6b0&scoped=true"
import script from "./Parcerias.vue?vue&type=script&lang=js"
export * from "./Parcerias.vue?vue&type=script&lang=js"
import style0 from "./Parcerias.vue?vue&type=style&index=0&id=49b5d6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b5d6b0",
  null
  
)

export default component.exports